import { Platform } from "@linkfluence/models/platform";
import { FullInfluencer } from "@radarly/models/influencer";

export interface InfluencerRepository {
  getInfluencerFromUid(
    project: number,
    influencerId: string
  ): Promise<FullInfluencer>;
  getInfluencer(
    project: number,
    platform: Platform,
    uid: string
  ): Promise<FullInfluencer>;
}

export const InfluencerRepositoryUID = Symbol("Radarly/InfluencerRepository");
